// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.
import teamMemberDeductionPayments from './team-member-deduction-payments.js';

export default [
    {
        path: '/:organisation/hr/team-member-deductions',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-deductions.vue'),
        name: 'human-resource.team-member-deductions.search-team-member-deductions',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.deductions.view-team-member-deductions',
        },

        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/hr/team-member-deductions/[id].vue'),
                name: 'human-resource.team-member-deductions.view-team-member-deduction',
                meta: {
                    loginRequired: true,
                    permission: 'access.human-resource.deductions.view-team-member-deductions',
                },
                children: [
                    {
                        path: 'new-payment',
                        component: () =>
                            import(/* webpackChunkName: "human-resource.team-member-deduction-payments" */ '@/pages/[organisation]/hr/team-member-deduction-payments/team-member-deduction-payment/new.vue'),
                        name: 'human-resource.team-member-deduction-payments.create-team-member-deduction-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.human-resource.deductions.create-team-member-deduction-payment',
                        },
                    },
                ],
            },
            ...teamMemberDeductionPayments,
        ],
    },
];
